import dayjs from 'dayjs';

export const formatDate = (date: Date | string | null, format = 'YYYY/MM/DD'): string => {
  if (date) {
    return dayjs(date).format(format);
  }
  return '-';
};
